import axiosInstance from "../../utils/axiosconfig";

const getSettings = async () => {
  const response = await axiosInstance.get(`settings`);
  return response.data;
};

const updateSettings = async (settingsData) => {
  const response = await axiosInstance.put(`settings/update-values`, settingsData);
  return response.data;
};

const settingsService = {
  getSettings,
  updateSettings,
};

export default settingsService;
